import { render, staticRenderFns } from "./DrawWinning.vue?vue&type=template&id=24865e52&scoped=true"
import script from "./DrawWinning.vue?vue&type=script&lang=js"
export * from "./DrawWinning.vue?vue&type=script&lang=js"
import style0 from "./DrawWinning.vue?vue&type=style&index=0&id=24865e52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24865e52",
  null
  
)

export default component.exports